<div class="maia-overlay" data-testid="maia-guidelines-panel" (click)="closed.emit()">

    <div class="guidelines-card" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">

        <header class="guidelines-header">
            <div class="guidelines-heading">
                <h2 class="guidelines-title">Upload Guidelines</h2>
                <button type="button"
                        class="guidelines-close"
                        data-testid="maia-guidelines-close-button"
                        aria-label="Close"
                        (click)="closed.emit()">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
                        <path d="m9.5 9.5 5 5M14.5 9.5l-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                </button>
            </div>
            <p class="guidelines-subtitle">
                Before preparing your file, make sure it meets the requirements below.
            </p>
        </header>

        <div class="guidelines-body">

            <section class="guidelines-section">
                <div class="section-heading">
                    <span class="section-icon section-icon-green" aria-hidden="true">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/>
                            <path d="m8.5 12.2 2.4 2.4 4.6-5" stroke="currentColor" stroke-width="1.7"
                                  stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <h3 class="section-title">Required</h3>
                </div>

                <ul class="guidelines-list">
                    <li *ngFor="let requirement of requirements" class="guidelines-item">
                        <svg class="item-icon item-icon-green" width="13" height="13" viewBox="0 0 24 24"
                             fill="none" aria-hidden="true">
                            <path d="m5 12.5 4.5 4.5L19 7" stroke="currentColor" stroke-width="2.4"
                                  stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span>{{ requirement }}</span>
                    </li>
                </ul>
            </section>

            <section class="guidelines-section">
                <div class="section-heading">
                    <span class="section-icon section-icon-blue" aria-hidden="true">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M13.5 3.5H7a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9z"
                                  stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
                            <path d="M13.5 3.5V9H19M8.5 13h7M8.5 16.5h4" stroke="currentColor"
                                  stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <h3 class="section-title">Supported file types</h3>
                </div>

                <div class="type-chips">
                    <span *ngFor="let type of supportedTypes"
                          class="type-chip"
                          [attr.data-testid]="'maia-guidelines-type-' + type">{{ type }}</span>
                </div>
            </section>

            <section class="guidelines-section">
                <div class="section-heading">
                    <span class="section-icon section-icon-red" aria-hidden="true">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M12 4.5 21 20H3z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
                            <path d="M12 10v4.5M12 17v.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
                        </svg>
                    </span>
                    <h3 class="section-title">Do not include</h3>
                </div>

                <ul class="guidelines-list">
                    <li *ngFor="let exclusion of exclusions" class="guidelines-item">
                        <svg class="item-icon item-icon-red" width="13" height="13" viewBox="0 0 24 24"
                             fill="none" aria-hidden="true">
                            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/>
                            <path d="m9.2 9.2 5.6 5.6M14.8 9.2l-5.6 5.6" stroke="currentColor"
                                  stroke-width="1.8" stroke-linecap="round"/>
                        </svg>
                        <span>{{ exclusion }}</span>
                    </li>
                </ul>
            </section>

        </div>

        <footer class="guidelines-footer">
            <h3 class="footer-title">Need a template?</h3>
            <p class="footer-text">
                Download a sample template to see the expected file structure before preparing your data.
            </p>
            <button type="button"
                    class="footer-button"
                    data-testid="maia-download-template-button"
                    [disabled]="isDownloadingTemplate"
                    (click)="templateRequested.emit()">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M12 4v10.5M8 11l4 4 4-4M4.5 19.5h15" stroke="currentColor" stroke-width="1.8"
                          stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                {{ isDownloadingTemplate ? 'Preparing…' : 'Download Template' }}
            </button>

            <p *ngIf="templateError" class="footer-error" data-testid="maia-template-error">
                {{ templateError }}
            </p>
        </footer>

    </div>
</div>
